import { addressToString, noop } from '@aloft/toolkit-shared';
import { Button, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-box, aloft/prefer-sound-ui-button
import { Box, Menu, MenuButton, MenuItem, MenuList } from '@aloft/toolkit-sui/chakra';

import { menuListProps, menuProps } from '../../../components/MainHeader/consts.ts';
import { selectAllPropertyIdentification } from '../../../redux/features/selectors/propertyDataSelectors/propertyIdentificationSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

export const ViewZillowListingButton = () => {
  const propertyIdentifications = useAppSelector(selectAllPropertyIdentification);

  return (
    <Menu {...menuProps} placement="bottom-end">
      <MenuButton as={Box} style={{ cursor: 'pointer' }}>
        <Button
          variant="secondary"
          size="sm"
          text="View Zillow Listing"
          rightIcon="arrow-down-s"
          onClick={noop}
        />
      </MenuButton>
      <MenuList {...menuListProps} minWidth="100px" zIndex={1000}>
        {propertyIdentifications.map(({ id, address }) => {
          const addressString = addressToString(address);

          return (
            <MenuItem
              key={id}
              onClick={() => {
                const escapedAddress = encodeURIComponent(addressString.replace(/ /g, '-'));
                const url = `https://www.zillow.com/homedetails/${escapedAddress}/2057490615_zpid/`;
                window.open(url, '_blank', 'noopener,noreferrer');
              }}
            >
              <Typography>{addressString}</Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
